import styled from 'styled-components';
import {Accordion} from 'react-bootstrap';

export const Panel = styled.div<{active?: boolean}>``;

export const CardContainer = styled.div`
  border: 1px solid #cccc;
  padding: 5px;
`;
